import { render, staticRenderFns } from "./PasswordFormStep.vue?vue&type=template&id=69772771&scoped=true&"
import script from "./PasswordFormStep.vue?vue&type=script&setup=true&lang=ts&"
export * from "./PasswordFormStep.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./PasswordFormStep.vue?vue&type=style&index=0&id=69772771&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69772771",
  null
  
)

export default component.exports